// extracted by mini-css-extract-plugin
module.exports = {"footer":"_93444fe79c--footer--24-va","metroWrapper":"_93444fe79c--metroWrapper--1LkdR"};